import { MTRouteTab } from '@/multi-territory/mt-types/mt-shared'
import { ROUTES } from '@/routes/routeConfig'

export const MTAdminTabs: MTRouteTab[] = [
  {
    id: 'entity',
    displayName: 'Entity',
    route: ROUTES.MT_ADMIN_ENTITY,
  },
  {
    id: 'tax-identification-number',
    displayName: 'Tax identification number',
    route: ROUTES.MT_ADMIN_TAX_IDENTIFICATION_NUMBER,
  },
  {
    id: 'user-setup',
    displayName: 'User setup',
    route: ROUTES.MT_ADMIN_USER_SETUP,
  },
  {
    id: 'assign-entity',
    displayName: 'Assign entity',
    route: ROUTES.MT_ADMIN_ASSIGN_ENTITY,
  },
  {
    id: 'compliance-master',
    displayName: 'Compliance master',
    route: ROUTES.MT_ADMIN_COMPLIANCE_MASTER,
  },
]
